import React from 'react';

import { graphql, useFragment } from 'react-relay';

import type { TeamButtonDataConnectedComponent$key } from './__generated__/TeamButtonDataConnectedComponent.graphql';
import { TeamButtonComponent } from './ui/team-button-component';

type Props = {
	containerId: string;
	data: TeamButtonDataConnectedComponent$key;
	Wrapper?: React.ElementType;
};

export const TeamButtonDataConnectedComponent = ({ containerId, Wrapper, data }: Props) => {
	const teams = useFragment(
		/* eslint-disable @atlassian/relay/unused-fields */
		graphql`
			fragment TeamButtonDataConnectedComponent on GraphStoreSimplifiedTeamConnectedToContainerInverseConnection {
				edges {
					id
				}
			}
		`,
		data,
	);

	const numberOfTeams = teams?.edges?.length;

	return (
		<TeamButtonComponent
			numberOfTeams={numberOfTeams}
			containerId={containerId}
			Wrapper={Wrapper}
		/>
	);
};
